var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.42222C0 0.63675 0.63675 0 1.42222 0H6.4C7.18549 0 7.82222 0.63675 7.82222 1.42222V4.26667C7.82222 5.05216 7.18549 5.68889 6.4 5.68889H4.97778L2.84444 7.82222V5.68889H1.42222C0.63675 5.68889 0 5.05216 0 4.26667V1.42222Z",
    fill: "#8B8A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24443 2.84442V4.26664C9.24443 5.83756 7.9709 7.11109 6.39998 7.11109H5.56687L4.31055 8.36741C4.50952 8.47329 4.73663 8.53331 4.97776 8.53331H6.39998L8.53332 10.6666V8.53331H9.95554C10.741 8.53331 11.3778 7.89658 11.3778 7.11109V4.26664C11.3778 3.48117 10.741 2.84442 9.95554 2.84442H9.24443Z",
    fill: "#8B8A90"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.69eb4f29.svg";
export { ForwardRef as ReactComponent };